export default "__VITE_ASSET__73e87cc8__"